/*
  Sticky header functionality, only shown when scrolling up. Solution is based on Shopify Dawn theme
  StickHeader element, see
  https://github.com/Shopify/dawn/blob/5cd1a859751a5fc00e4dd8cf048ee8a67c4bb356/sections/header.liquid#L298
 */

export default function init() {
  const target = document.querySelector<HTMLElement>('.js-sticky-header')!;

  // Set up header height and resize callbacks
  setHeaderHeight(target);
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      setHeaderHeight(entry.target as HTMLElement);
    }
  });
  resizeObserver.observe(target);
}

function setHeaderHeight(target: HTMLElement) {
  document.documentElement.style.setProperty(
    '--header-height',
    `${target.offsetHeight + target.offsetTop}px`,
  );
}
